module.exports = __webpack_public_path__ + "img/bg.2129088.png";